import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab } from 'theme/components/Tabs/Tabs';
import Styles from './OfficePageListCountries.scss';

const OfficePageCountries = ({
  countries,
  setActiveCountry,
  activeCountry
}) => (
  <Tabs className={Styles.countriesList}>
    {countries.map((country) => (
      <Tab
        key={country}
        name={country}
        onClick={() => setActiveCountry(country)}
        isActive={activeCountry === country}
      />
    ))}
  </Tabs>
);

OfficePageCountries.propTypes = {
  countries: PropTypes.array,
  activeCountry: PropTypes.string,
  setActiveCountry: PropTypes.func,
};

export default OfficePageCountries;
